document.addEventListener("DOMContentLoaded", function () {
  const wishlistBtns = document.querySelectorAll(".wishlist-btn");

  wishlistBtns.forEach((btn) => {
    const productId = btn.dataset.productId;
    const handle = btn.dataset.productHandle;

    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

    // Check if already added
    if (wishlist.find((p) => p.id === productId)) {
      btn.textContent = "❤️ Added to Wishlist";
      btn.classList.add("active");
    }

    btn.addEventListener("click", function () {
      wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

      const exists = wishlist.find((p) => p.id === productId);

      if (exists) {
        // Remove product
        wishlist = wishlist.filter((p) => p.id !== productId);
        btn.textContent = "❤️ Add to Wishlist";
        btn.classList.remove("active");
      } else {
        // Add product
        wishlist.push({
          id: productId,
          handle: handle,
        });
        btn.textContent = "💖 Added to Wishlist";
        btn.classList.add("active");
      }

      localStorage.setItem("wishlist", JSON.stringify(wishlist));
    });
  });
});
